import { Site } from "./SitesTypes";

export type UserAccount = {
  email?: string;
  name?: string;
  nickname?: string;
  phone?: string;
  accounts?: Account[];
  firstAccess?: boolean;
};

export type Account = {
  astvId?: number;
  email?: string;
  licenses: Site[];
  name: string;
  subscription?: Subscription;
};

export type Subscription = {
  planCode: string;
  planName: string;
  planType: PlanType;
  planDescription: string;
  statusLabel: string;
  active: boolean;
  status: "TRIAL" | "ACTIVE" | "GRACE" | "EXPIRED" | "INCOMPLETE" | "PROVISIONING" | "SUSPENDED" | "CANCELLED" | "DISABLED";
  daysUntilRenewal: number;
  expirationDate: string;
  usedDomain?: number;
  maxDomain?: number;
  pageViews?: number;
  maxPageViews?: number;
};

export type Plan = {
  code: string;
  name: string;
  planInfo?: string;
  type: PlanType;
  subtitle?: string;
  description: string;
  licensesLimit?: number;
  monthlyPrice?: number;
  annualPrice?: number;
  mostChosen?: boolean;
};

export enum PlanType {
  TRIAL = "TRIAL",
  FREE = "FREE",
  ESSENTIAL = "ESSENTIAL",
  ADVANCED = "ADVANCED",
  ENTERPRISE = "ENTERPRISE",
}

export type BillingData = {
  taxpayerType: "FISICA" | "JURIDICA";
  cnpj: string;
  cpf: string;
  corporateName: string;
  fantasyName: string;
  simple: boolean;
  financialFullName: string;
  financialEmail: string;
  financialPhone: string;
  billingZipCode: string;
  billingAddress: string;
  billingAddressNumber: string;
  billingComplement: string;
  billingDistrict: string;
  billingCity: string;
  billingCountry: string;
  billingState: string;
};

export type CEPEndereco = {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  ibge: string;
  gia: string;
  ddd: string;
  siafi: string;
};

export type SubscriptionAccountUpdate = {
  plan?: string,
  cicleType: string,
  autoRenew: boolean
}
